// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { competenciesManifest } from './competencies';
import { learningManifest } from './learning';
import { mentoringManifest } from './mentoring';

/** Група модулів «Розвиток» (Development): 3 модулів. */
export const developmentGroup: IModuleGroupManifest = {
  key: 'development',
  category: 'Development',
  name: { en: 'Development', uk: 'Розвиток' },
  sort: 5,
  modules: [competenciesManifest, learningManifest, mentoringManifest],
};
